export function Logo() {
  return <h1>🌴 Far Away 🌴🎒</h1>;
}
